import React, { useEffect, useState } from "react";
import {
  formPagoMovil,
  optionPhone,
  optionPyment,
} from "../../../../../propsType/Payemnts";
import { validatePagoMovil } from "../../../../../validations/formValidations";
import { useForm } from "../../../../../Hooks/UseForm";
import PagosController from "../../../../../controllers/PagosController";
import SelectGeneric from "../../../../../components/Inputs/SelectGeneric";
import InputGeneric from "../../../../../components/Inputs/InputGeneric";
import ButtonGeneric from "../../../../../components/Buttons/ButtonGeneric";
import bills from "../../../../../assets/png/bill.png";
import Spinner from "../../../../../components/Loading/loadingSpinner/Spinner";
import { extrac } from "../../../../../helpers/selectForm";
import Modal from "../../../../../components/Modals/Modal";
import logo from "../../../../../assets/bancos/newLogos/bancamiga-501.png";
import logoMercantil from "../../../../../assets/bancos/newLogos/mercantil-501.png";
import moment from "moment";
import { ClipboardIcon } from "@heroicons/react/solid";
import { InformationCircleIcon } from "@heroicons/react/outline";
import { useLocation } from "react-router-dom";

function Pagomovil({
  data,
  setData,
  stapsState,
  setStapsState,
  back,
  deatils,
}) {

  const { form, errors, setForm, handleChange, handleSubmit, handleBlur } = useForm(formPagoMovil, validatePagoMovil);
  const { notificacionP2C, afilicacionP2C, getBancos, desAfilicacionP2C } =
    PagosController();
  const [banks, setBanks] = useState([""]);
  const [loading, setLoading] = useState(false);
  const [errorModal, setErrorModal] = useState(false);
  const [message, setMessage] = useState("");
  const [imgModal, setImgModal] = useState(null);
  const [icon, setIcon] = useState(null);
  const [toast, setToast] = useState(false);
  const [toast2, setToast2] = useState(false);
  const [toast3, setToast3] = useState(false);
  const location = useLocation();
  const [isCheckedBancamiga, setIsCheckedBancamiga] = useState(false);
  const [isCheckedMercantil, setIsCheckedMercantil] = useState(false);
  const getBanks = async () => {
    setLoading(true);
    const idCuenta = location.state.data.nroCuenta;
    const resBancos = await getBancos(idCuenta);
    if (resBancos) {
      setBanks(resBancos);
      setLoading(false);
    }
  };

  const handleOnChangeBancamiga = () => {
    setIsCheckedMercantil(false);
    setIsCheckedBancamiga(!isCheckedBancamiga);

  };
  const handleOnChangeMercantil = () => {
    setIsCheckedBancamiga(false);
    setIsCheckedMercantil(!isCheckedMercantil);
  };
  const pagar = async () => {
    const result = handleSubmit();
    let resBanco = JSON.parse(form.banks);
    let medioPago = "";
    let isBanco = "false";
    if ((isCheckedBancamiga == false) && (isCheckedMercantil == false)) {
      setErrorModal(true);
      setImgModal("error");
      setIcon(false);
      setMessage("Por favor selecciona el banco al cuál realizaste el pago móvil");
      isBanco = "true"
    }
    else if (isCheckedBancamiga == true) { medioPago = "BANCAMIGA"; }
    else if (isCheckedMercantil == true) { medioPago = "MERCANTIL"; }
    if ((result === "ok") && (isBanco === "false")) {
      setLoading(true);
      const resDoc = extrac(form.selectDoc);
      let dataNotificacion = {
        monto: data.metodoAPagar,
        referencia: form.numberReference,
        codigoBanco: resBanco.codigo,
        banco: medioPago,
        docType: form.selectDoc,
        cedula: form.typeDoc,
        telefonoP: form.selectNumber + form.phone,
        fecha: form.date,
        idCuenta: location.state.data.nroCuenta,
        idPago: Math.round(Math.random() * 10000000000),
      };
      const resNotificacion = await notificacionP2C(dataNotificacion);
      switch (resNotificacion.respuesta) {
        case "0":
          setData({ ...data, exitoso: true, transaccion: dataNotificacion.idPago, monto: dataNotificacion.monto, fecha: dataNotificacion.fecha });
          setStapsState({
            ...stapsState,
            option1: false,
            option2: false,
            option3: false,
            option4: false,
            option5: true,
          });
          break;
        case "1":
          setData({ ...data, transaccion: dataNotificacion.idPago, monto: dataNotificacion.monto, fecha: dataNotificacion.fecha });
          setStapsState({
            ...stapsState,
            option1: false,
            option2: false,
            option3: false,
            option4: false,
            option5: true,
          });
          break;
        default:
          setLoading(false);
          setErrorModal(true);
          setImgModal("error");
          setIcon(false);
          setMessage(resNotificacion.descripcion);
          break;
      }
    }
  };

  function filtro(e) {
    if (form.selectDoc !== "P"){
      var tecla = e.key;
      if (['.', 'e','E' ].includes(tecla))
        e.preventDefault()}
  }
  
  const copie = (value) => {
    switch (value) {
      case 1:
        navigator.clipboard.writeText("0424-199-4141");
        setToast(true);
        setTimeout(() => {
          setToast(false);
        }, 800);
        break;
      case 2:
        navigator.clipboard.writeText("J-30108335-0");
        setToast2(true);
        setTimeout(() => {
          setToast2(false);
        }, 800);
        break;
      case 3:
        navigator.clipboard.writeText("Bancamiga");
        setToast3(true);
        setTimeout(() => {
          setToast3(false);
        }, 800);
        break;
      default:
        setToast(false);
        break;
    }
  };
  useEffect(() => {
    getBanks();
  }, []);


  return (
    <>
      <>
        <div className="flex lg:pt-[100px]  pt-[220px] flex-col-reverse px-5 pb-6 lg:flex-row lg:pb-7  lg:px-[28px] gap-4 relative">
          <div className="lg:w-[70%]  ">
            {loading ? (
              <>
                <div className="w-full h-full flex justify-center items-center">
                  <Spinner title={"Espere por favor..."} />
                </div>
              </>
            ) : (
              <>
                <div className="absolute left-0 top-0 w-full ">
                  <div className="bg-white w-full px-4 py-5 border-b border-gray-200 sm:px-6">
                    <div className="-ml-4 -mt-4 flex justify-between items-center flex-wrap sm:flex-nowrap">
                      <div className="ml-4 mt-4">
                        <h3 className="text-2xl leading-6 font-medium text-gray-900">
                          Paga y Notifica
                        </h3>
                        <p className="mt-1 text-sm text-gray-500">
                          Para notificar debe haber  realizado antes el pago través  de su institución financiera.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="h-full flex flex-col  justify-between lg:pr-[50px] ">
                  <p className="text-sm font-medium text-gray-900">
                    Selecciona el Banco Receptor (NetUno).
                  </p>
                  <div className="sm:grid sm:grid-cols-2 sm:gap-4 ">
                    <div className="grid">
                      <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                        <ul
                          role="list"
                          className="border border-gray-200 rounded-md divide-y divide-gray-200"
                        >
                          <li className="pl-3 pr-4 py-3 flex items-center justify-between text-sm">
                            <div className="w-0 flex-1 flex items-center">
                              <span className="ml-2 flex-1 w-0 truncate">
                                Número de Teléfono:{" "}
                              </span>
                            </div>
                            <div className="ml-4 flex-shrink-0 relative">
                              <div
                                class={` ${toast
                                  ? "visible transition-all ease-in duration-800 opacity-100 "
                                  : "invisible opacity-0"
                                  } bg-grey-lightest border-l-4 absolute  bg-white w-[112px] -top-[9px] -right-[16px] border-[#5ab9e5] p-[10px] rounded shadow-lg flex items-center justify-between`}
                                role="alert"
                              >
                                <span class="fa-stack fa-2x sm:mr-2 mb-3">
                                  <i class="fas fa-circle text-red-dark fa-stack-2x"></i>
                                  <i class="fas fa-hand-paper fa-stack-1x text-white"></i>
                                </span>

                                <i class="fas fa-times mx-4 fa-2x text-grey-darker"></i>
                              </div>
                              <p

                                className=" cursor-pointer font-medium text-[#5ab9e5] hover:text-[#5ab9e5] "
                              >
                                (0424) 1994141
                              </p>
                            </div>
                          </li>
                          <li className="pl-3 pr-4 py-3 flex items-center justify-between text-sm">
                            <div className="w-0 flex-1 flex items-center">
                              <span className="ml-2 flex-1 w-0 truncate">
                                Número de RIF:{" "}
                              </span>
                            </div>
                            <div className="ml-4 flex-shrink-0 relative">
                              <div
                                class={` ${toast2
                                  ? "visible transition-all ease-in duration-800 opacity-100 "
                                  : "invisible opacity-0"
                                  } bg-grey-lightest border-l-4 absolute  bg-white w-[112px] -top-[9px] -right-[16px] border-[#5ab9e5] p-[10px] rounded shadow-lg flex items-center justify-between`}
                                role="alert"
                              >
                                <span class="fa-stack fa-2x sm:mr-2 mb-3">
                                  <i class="fas fa-circle text-red-dark fa-stack-2x"></i>
                                  <i class="fas fa-hand-paper fa-stack-1x text-white"></i>
                                </span>

                                <i class="fas fa-times mx-4 fa-2x text-grey-darker"></i>
                              </div>
                              <p

                                className=" cursor-pointer font-medium text-[#5ab9e5] hover:text-[#5ab9e5] "
                              >
                                J-30108335-0
                              </p>
                            </div>
                          </li>
                          <li className="pl-3 pr-4 py-3 flex items-center justify-between text-sm">
                            <div className="w-0 flex-1 flex items-center">
                              <input
                                type={"checkbox"}
                                className="text-sm font-medium"
                                name={"form.chkBancamiga"}
                                checked={isCheckedBancamiga}
                                onChange={handleOnChangeBancamiga}
                                value={form.chkBancamiga} />
                            </div>
                            <div className="ml-4 flex-shrink-0 relative">
                              <div
                                class={` ${toast3
                                  ? "visible transition-all ease-in duration-800 opacity-100 "
                                  : "invisible opacity-0"
                                  } bg-grey-lightest border-l-4 absolute  bg-white w-[112px] -top-[9px] -right-[16px] border-[#5ab9e5] p-[10px] rounded shadow-lg flex items-center justify-between`}
                                role="alert"
                              >
                                <span class="fa-stack fa-2x sm:mr-2 mb-3">
                                  <i class="fas fa-circle text-red-dark fa-stack-2x"></i>
                                  <i class="fas fa-hand-paper fa-stack-1x text-white"></i>
                                </span>

                                <i class="fas fa-times mx-4 fa-2x text-grey-darker"></i>
                              </div>
                              <img src={logo}></img>

                            </div>
                          </li>
                        </ul>
                      </dd>
                    </div>

                    <div className="grid">
                      <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                        <ul
                          role="list"
                          className="border border-gray-200 rounded-md divide-y divide-gray-200"
                        >
                          <li className="pl-3 pr-4 py-3 flex items-center justify-between text-sm">
                            <div className="w-0 flex-1 flex items-center">
                              <span className="ml-2 flex-1 w-0 truncate">
                                Número de Teléfono:{" "}
                              </span>
                            </div>
                            <div className="ml-4 flex-shrink-0 relative">
                              <div
                                class={` ${toast
                                  ? "visible transition-all ease-in duration-800 opacity-100 "
                                  : "invisible opacity-0"
                                  } bg-grey-lightest border-l-4 absolute  bg-white w-[112px] -top-[9px] -right-[16px] border-[#5ab9e5] p-[10px] rounded shadow-lg flex items-center justify-between`}
                                role="alert"
                              >
                                <span class="fa-stack fa-2x sm:mr-2 mb-3">
                                  <i class="fas fa-circle text-red-dark fa-stack-2x"></i>
                                  <i class="fas fa-hand-paper fa-stack-1x text-white"></i>
                                </span>

                                <i class="fas fa-times mx-4 fa-2x text-grey-darker"></i>
                              </div>
                              <p

                                className=" cursor-pointer font-medium text-[#5ab9e5] hover:text-[#5ab9e5] "
                              >
                                (0424) 1994141
                              </p>
                            </div>
                          </li>
                          <li className="pl-3 pr-4 py-3 flex items-center justify-between text-sm">
                            <div className="w-0 flex-1 flex items-center">
                              <span className="ml-2 flex-1 w-0 truncate">
                                Número de RIF:{" "}
                              </span>
                            </div>
                            <div className="ml-4 flex-shrink-0 relative">
                              <div
                                class={` ${toast2
                                  ? "visible transition-all ease-in duration-800 opacity-100 "
                                  : "invisible opacity-0"
                                  } bg-grey-lightest border-l-4 absolute  bg-white w-[112px] -top-[9px] -right-[16px] border-[#5ab9e5] p-[10px] rounded shadow-lg flex items-center justify-between`}
                                role="alert"
                              >
                                <span class="fa-stack fa-2x sm:mr-2 mb-3">
                                  <i class="fas fa-circle text-red-dark fa-stack-2x"></i>
                                  <i class="fas fa-hand-paper fa-stack-1x text-white"></i>
                                </span>

                                <i class="fas fa-times mx-4 fa-2x text-grey-darker"></i>
                              </div>
                              <p

                                className=" cursor-pointer font-medium text-[#5ab9e5] hover:text-[#5ab9e5] "
                              >
                                J-30108335-0
                              </p>
                            </div>
                          </li>
                          <li className="pl-3 pr-4 py-3 flex items-center justify-between text-sm">
                            <div className="w-0 flex-1 flex items-center">
                              <input
                                type={"checkbox"}
                                className="text-sm font-medium"
                                name={"form.chkMercantil"}
                                checked={isCheckedMercantil}
                                onChange={handleOnChangeMercantil}
                                value={form.chkMercantil} />
                            </div>
                            <div className="ml-4 flex-shrink-0 relative">
                              <div
                                class={` ${toast3
                                  ? "visible transition-all ease-in duration-800 opacity-100 "
                                  : "invisible opacity-0"
                                  } bg-grey-lightest border-l-4 absolute  bg-white w-[112px] -top-[9px] -right-[16px] border-[#5ab9e5] p-[10px] rounded shadow-lg flex items-center justify-between`}
                                role="alert"
                              >
                                <span class="fa-stack fa-2x sm:mr-2 mb-3">
                                  <i class="fas fa-circle text-red-dark fa-stack-2x"></i>
                                  <i class="fas fa-hand-paper fa-stack-1x text-white"></i>
                                </span>
                                <i class="fas fa-times mx-4 fa-2x text-grey-darker">kjknk</i>
                              </div>
                              <img src={logoMercantil}></img>
                            </div>
                          </li>
                        </ul>
                      </dd>
                    </div>
                  </div>
                  <hr className="pt-[10px] mt-[10px]" />
                  <p className="text-sm font-medium text-gray-900">
                    Si ya realizó el pago por favor notifique completando los
                    siguientes datos:
                  </p>
                  <div className="h-[80%] gap-[15px] relative flex flex-col justify-start mt-3 ">
                    <div className=" grid gap-3 lg:grid-cols-2 lg:gap-10">
                      <div className="grid">
                        <div className="flex gap-[3px] items-center text-gray-900">
                          <p className=" text-sm font-medium  ">
                            Documento de Identidad
                          </p>
                          <p>
                            <div
                              className={` button cursor-pointer !w-[14px]`}
                              data-tooltip={
                                "Del emisor o titular del Pago Móvil"
                              }
                            >
                              <InformationCircleIcon className=" button !w-[14px]  cursor-pointer  text-green " />
                            </div>
                          </p>
                        </div>

                        <div className="grid !mt-1  grid-cols-7">
                          <div className="col-span-2">
                            <SelectGeneric
                              onChange={handleChange}
                              value={form.selectDoc || ""}
                              name={"selectDoc"}
                              onBlur={handleBlur}
                              errors={errors.selectDoc}
                              selectData={optionPyment}
                            />
                          </div>
                          <div className="col-span-5">
                            <InputGeneric
                              name={"typeDoc"}
                              type={form?.selectDoc === "P" ? "text" : "number"}
                              onKeyDown={(e) => filtro(e)}
                              maxValue={13}
                              value={form.typeDoc}
                              onChange={handleChange}
                              handleBlur={handleBlur}
                              errorText={errors.typeDoc}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="grid">
                        <div className="flex gap-[3px] items-center text-gray-900">
                          <p className="text-sm font-medium  ">Nº Celular</p>
                          <p>
                            <div
                              className={` button cursor-pointer !w-[14px]`}
                              data-tooltip={
                                "Número de teléfono afiliado a Pago Móvil"
                              }
                            >
                              <InformationCircleIcon className=" button !w-[14px]  cursor-pointer  text-green " />
                            </div>
                          </p>
                        </div>
                        <div className="grid !mt-1  grid-cols-7">
                          <div className="col-span-2">
                            <SelectGeneric
                              onChange={handleChange}
                              value={form.selectNumber || ""}
                              name={"selectNumber"}
                              onBlur={handleBlur}
                              errors={errors.selectNumber}
                              selectData={optionPhone}
                            />
                          </div>
                          <div className="col-span-5">
                            <InputGeneric
                              name={"phone"}
                              type={"number"}
                              value={form.phone}
                              onChange={handleChange}
                              handleBlur={handleBlur}
                              errorText={errors.phone}
                              maxValue={7}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className=" grid gap-3 lg:grid-cols-2 lg:gap-10">
                      <InputGeneric
                        name={"numberReference"}
                        title={"Número de Referencia"}
                        type={"number"}
                        textTopTips={
                          "Número completo de la referencia de su Pago Móvil"
                        }
                        iconTop={true}
                        value={form.numberReference}
                        handleBlur={handleBlur}
                        onChange={handleChange}
                        errorText={errors.numberReference}
                        maxValue={12}
                      />
                      <InputGeneric
                        type={"date"}
                        textTopTips={"Fecha exacta de realizado el Pago Móvil"}
                        iconTop={true}
                        maxProps={moment().format("YYYY-MM-DD")}
                        title={"Fecha del Pago"}
                        value={form.date}
                        onChange={handleChange}
                        handleBlur={handleBlur}
                        name={"date"}
                        errorText={errors.date}
                      />
                    </div>
                    <div className=" grid gap-3 lg:grid-cols-2 lg:gap-10 place-items-end">
                      <div className="w-full space-y-1">
                        <div className=" flex items-center gap-[3px] text-gray-900">
                          <p className="text-sm font-medium">
                            Banco Emisor del Pago Móvil
                          </p>
                          <p>
                            <div
                              className={` button cursor-pointer !w-[14px]`}
                              data-tooltip={
                                "Selecciona el banco desde donde se realiza el Pago Móvil"
                              }
                            >
                              <InformationCircleIcon className=" button !w-[14px]  cursor-pointer  text-green " />
                            </div>
                          </p>
                        </div>
                        <SelectGeneric
                          selectData={banks.bancos}
                          name={"banks"}
                          onBlur={handleBlur}
                          value={form.banks || ""}
                          onChange={handleChange}
                          errors={errors.banks}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="mt-5 ">
                    <p className="text-[0.8rem] text-[#798791]">
                      El monto de su pago móvil debe ser exactamente igual al
                      monto indicado en el campo “Monto a Pagar”.
                    </p>
                  </div>
                  <hr className="pt-[10px] mt-[10px]" />

                  <div className="w-full flex justify-between gap-[50%]">
                    <div className="w-full">
                      <ButtonGeneric funtion={back} text={"Volver"} />
                    </div>
                    <div className="w-full">
                      <ButtonGeneric funtion={pagar} text={"Notificar"} />
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
          <div className="lg:w-[30%] relative sha">
            <div
              className="bg-[#005dff0a] w-full h-[400px] relative flex justify-center rounded-[5%]   
                                    before:content-[''] 
                                    before:absolute 
                                    before:w-[45px] 
                                    before:h-[45px] 
                                    before:rounded-full 
                                    before:bg-white 
                                    before:bottom-[-20px]
                                    before:left-[-20px]
                                    after:content-[''] 
                                    after:absolute 
                                    after:w-[45px] 
                                    after:h-[45px] 
                                    after:rounded-full 
                                    after:bg-white 
                                    after:bottom-[-20px]
                                    after:right-[-20px] 
                    "
            >
              <div
                className={` bg-[url("../public/bgCard.jpg")] bg-right bg-auto bg-no-repeat w-[80%] flex flex-col justify-between absolute lg:w-[80%] h-[85%] shadow-xl rounded-[10%] top-[-25%]  z-[8] p-[2rem]`}
              >
                <div className="flex w-full justify-center absolute top-0  right-0  ">
                  <div className="border-blue-500 border-2 shadow-xl w-[30%] shadowTarjet shadow-blue-500 "></div>
                </div>
                <div className="flex justify-center items-center">
                  <div className="w-[70%] object-contain">
                    <img
                      className="w-full object-contain "
                      src={data.metodoPago.logo}
                      alt=""
                    />
                  </div>
                </div>
                <div className="h-40% grid gap-[10px]">
                  <div className="font-medium text-center">
                    {data.metodoPago.title}{" "}
                  </div>
                  <div className="flex flex-col justify-between items-center">
                    <div className="font-medium text-center ">
                      {" "}
                      <div className="whitespace-nowrap">
                        Número de cuenta
                      </div>{" "}
                    </div>
                    <div className="text-center"> {deatils.nroCuenta} </div>
                  </div>
                  <div className="flex flex-col justify-between items-center">
                    <div className="font-medium w-full text-center">Moneda</div>
                    <div className=" w-full text-center">
                      {data?.data?.title}{" "}
                    </div>
                  </div>
                </div>
              </div>
              <div className="flex flex-col justify-end w-full p-5 gap-4">
                <div className="flex justify-between ">
                  <div className="text-[#798791] ">
                    {
                      deatils?.deudaTotalVEF < "0" || deatils?.deudaTotalUSD < "0" ?
                        (
                          <>
                            Saldo a favor
                          </>
                        )
                        :
                        (
                          <>
                            Saldo
                          </>
                        )
                    }

                  </div>{" "}
                  <div className="font-medium">Bs {deatils?.deudaTotalVEF}</div>
                </div>
              </div>
            </div>
            <div className="w-full flex justify-center ">
              <div className="w-[80%] border-dashed  border-t-[2px] border-[#c8c8c8]"></div>
            </div>
            <div className="bg-[#005dff0a] h-[100px] rounded-[10%]">
              <div className="w-full p-5 flex justify-between items-center">
                <div>
                  <div className="text-[#798791] ">Monto a Pagar</div>
                  <div className="text-2xl font-medium">
                    <span className="text-[#798791] pr-2 ">Bs</span>
                    {data?.metodoAPagar}
                  </div>
                </div>
                <div className="w-[35px] ">
                  <img src={bills} alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
      <Modal
        active={errorModal}
        message={message}
        setActive={setErrorModal}
        string={icon ? "check" : "error"}
      >
        <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
          {/*  <button type="button" onClick={() => success()} className="inline-flex w-full justify-center rounded-md bg-green-500 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500 sm:ml-3 sm:w-auto">Continuar</button> */}

          {!icon && (
            <button
              type="button"
              onClick={() => setErrorModal(false)}
              className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
            >
              Aceptar
            </button>
          )}
        </div>
      </Modal>
    </>
  );
}

export default Pagomovil;
